import React from 'react';
import { LockClosedIcon as HeroLockClosedIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type LockClosedIconProps = Omit<IconProps, 'children'>;

export const LockClosedIcon: React.FC<LockClosedIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroLockClosedIcon />
        </Icon>
    );
};
